import {ModifyTileStoreFunctionType, Tile, TileCoordinates, TileCoordinateType, TileData} from "./Tile";
import {TRAY_LENGTH} from "./constants";

export function Tray(props: {tiles: Array<TileData>, modifyTileStore: ModifyTileStoreFunctionType, trayCoordinateType: TileCoordinateType}) {
    const divContent = [];
    for(let i = 0; i<TRAY_LENGTH; i++){
        const tileData = props.tiles[i];

        if(tileData != null){
            divContent.push(
                <Tile key={i} data={tileData} modifyTileStore={props.modifyTileStore}/>
            );
        } else{
            const coordinate: TileCoordinates = {
                index: i,
                location: props.trayCoordinateType
            };
            divContent.push(<EmptyTraySpot key={i} coordinate={coordinate} modifyFunction={props.modifyTileStore}/>);
        }
    }

    return (
        <div className="tray">
            {divContent}
        </div>
    );


}


function EmptyTraySpot(props: {coordinate: TileCoordinates, modifyFunction}){

    function onDrop(e){
        const tileData: TileData = JSON.parse(e.dataTransfer.getData("scrapple/tile"));
        tileData.isEphemeral = false;

        console.log({tileData})

        props.modifyFunction(props.coordinate, tileData);

        e.preventDefault();
    }

    return(<div className="empty-tray-tile" onDrop={onDrop} onDragOver={(e) => e.preventDefault()}/>);


}